<section class="folder-doesnt-exist" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon>description</mat-icon>
  <p>Oops! We can't seem to find the folder <br> you are looking for</p>
  <p class="link" (click)="handleGoToFiles()">Go to All Files</p>
</section>